import { Helmet } from "react-helmet-async";
import profileImage from "../../Images/profileimg.png";

const SeoGeneral = ({ data }) => {
    return (
        <Helmet>
            <title>{data?.title || "Neoosearch"}</title>
            <meta name="description" content={data?.description || "NeooSearch business listing pricing and plans – Pick the right account from Startup to Enterprise with flexible pricing and powerful features to grow your business."} data-rh="true" />
            <meta property="og:image" content={data?.ogImage || profileImage} data-rh="true" />
            {data?.url && <meta property="og:url" content={data?.url} data-rh="true" />}
            {data?.keywords && <meta name="keywords" content={data?.keywords} data-rh="true" />}
            {data?.type && <meta name="type" content={data?.type} data-rh="true" />}
            {data?.site_name && <meta name="site_name" content={data?.site_name} data-rh="true" />}
            {data?.canonical && <link rel="canonical" href={data?.canonical} />}
            {data?.keywords && <meta name="keywords" content={data?.keywords} data-rh="true" />}

            <meta name="twitter:card" content="summary_large_image" data-rh="true" />
            <meta name="twitter:title" content={data?.title || "Neoosearch"} data-rh="true" />
            <meta name="twitter:description" content={data?.description || "NeooSearch business listing pricing and plans – Pick the right account from Startup to Enterprise with flexible pricing and powerful features to grow your business."} data-rh="true" />
            <meta name="twitter:image" content={data?.ogImage || profileImage} data-rh="true" />
            <meta name="twitter:image:alt" content={data?.ogImageAlt || "NeooSearch"} data-rh="true" />
        </Helmet>
    );
};
export default SeoGeneral;